const LanguageService = {
  getCurrentTYPO3Language() {
    const settingsNode = document.getElementById('ed-settings');
    return settingsNode.dataset.lang;
  },
};

export default LanguageService;
